import { sendHDMLoginCompleteEvent } from '@/data/events/handlers/gtm/HDMLoginComplete';
import { HDMUserActionCompletePayload } from '@/data/types/HDMGTM';

export const hdmLoginCompleteDelegator = async (payload: HDMUserActionCompletePayload) => {
	if (payload) {
		await sendHDMLoginCompleteEvent(payload);
	}
};
